import _ from 'lodash'

import VALUES from 'core/data-model/constants/values'

import { isNil, isNotNil } from 'core/service/lib/type-check'
import { createSelector } from 'reselect'
import { getSelectedDisplayProduct, getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'
import DEFAULTS from 'core/data-model/constants/defaults'

import {
  getSumAssured$,
  getSelectedRiders,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
} from 'quick-quote/product-common/coverage-plan/selectors'

export const canProceedToBenefitIllustration = createSelector(
  getSumAssured$,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
  getSelectedRiders,
  canProceedToCoveragePlan,
  getSelectedDisplayProduct,
  (
    sumAssured$,
    basicPremium,
    totalPremium$,
    basicPlanErrorMessage,
    selectedRiders,
    canProceedToCoveragePlan,
    selectedDisplayProduct
  ) => {
    const selectedRiderInvalidMessages = selectedRiders.filter((rider) =>
      isNotNil(rider.errors.find((error) => error.type === VALUES.VALIDATION))
    )

    const canProceed =
      canProceedToCoveragePlan &&
      sumAssured$.isOk &&
      basicPremium.isOk &&
      totalPremium$.isOk &&
      _.isEmpty(selectedRiderInvalidMessages) &&
      _.isEmpty(basicPlanErrorMessage)
    if (selectedDisplayProduct.type === VALUES.CAMPAIGN_PRODUCT_TYPE) {
      const selectedRiderCodes = selectedRiders.map((rider) => rider.code)
      return (
        canProceed &&
        selectedDisplayProduct.requiredRiders != null &&
        selectedDisplayProduct.requiredRiders.every((riderCode) => {
          return selectedRiderCodes.indexOf(riderCode) > -1
        })
      )
    }
    return canProceed
  }
)

export const getSelectedProductLifeProtectPlus = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_UNDER:
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_HIGHER:
      return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_HIGHER
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_UNDER:
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_HIGHER:
      return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_HIGHER
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_UNDER:
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_HIGHER:
      return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_HIGHER
    default:
      return productCode
  }
})

export const getBoosterSA = (state) => {
  const boosterSA = _.get(state, 'coveragePlan.boosterSA')
  return isNil(boosterSA) ? null : boosterSA
}

export const getSelectedBoosterPlan = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_UNDER:
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_UNDER:
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_UNDER:
      return VALUES.BOOSTER_SA_PLAN.FIFTY_PERCENT
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_HIGHER:
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_HIGHER:
    case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_HIGHER:
    case VALUES.COMBO_CI_LIFEPROTECT_PLUS_CODE.WLF19H:
    case VALUES.COMBO_CI_LIFEPROTECT_PLUS_CODE.WLF99H:
    case VALUES.COMBO_HEALTH_ESSENTIAL_LIFEPROTECT_PLUS_CODE.WLF19H:
    case VALUES.COMBO_HEALTH_ESSENTIAL_LIFEPROTECT_PLUS_CODE.WLF99H:
      return VALUES.BOOSTER_SA_PLAN.ONE_HUNDRED_PERCENT
    default:
      return VALUES.BOOSTER_SA_PLAN.ONE_HUNDRED_PERCENT
  }
})
